import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';
import { Option } from '../option';

export interface SelectFieldModel extends BaseFieldModel {
  defaultValue: string | undefined;
  placeholder: CultureTextModel[] | string;
  options: Option[];
  type: FieldType.Select;
}

export class SelectField extends BaseField implements SelectFieldModel {
  public defaultValue: string | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public options: Option[] = [];
  public type: FieldType.Select = FieldType.Select;

  constructor(cultures: string[]) {
    super(FieldType.Select, cultures);

    this.placeholder = [];

    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }
}
